import { BaseEntity, Entity as DecribeEntity } from '@avangard/utils/entity';

import type { StudentOnlineApplicationRecreation } from '@modules/types/graphql';

export type Entity = Partial<StudentOnlineApplicationRecreation> | null;

@DecribeEntity('StudentOnlineApplicationRecreationEntity')
class StudentOnlineApplicationRecreationEntity extends BaseEntity {
    selfLeft: '0' | '1';
    assesment: string;
    count: string;
    fromAge: string;
    mood: string;

    constructor(entity: Entity) {
        super(entity);

        this.selfLeft = (entity?.selfLeft as '0' | '1') ?? '0';
        this.assesment = entity?.assesment ?? '';
        this.count = entity?.count ?? '';
        this.fromAge = entity?.fromAge ?? '';
        this.mood = entity?.mood ?? '';
    }
}

export { StudentOnlineApplicationRecreationEntity };
